module.exports = __webpack_public_path__ + "static/img/3.b454139.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/6/1/3/sp/3.png
// module id = k+um
// module chunks = 0